<template>
  <BreadCrumb PageTitle="Détails du marchand" />
  <ViewMarchand />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
  import ViewMarchand from "../../../components/Ecommerce/Marchand/ViewMarchand.vue";

  export default defineComponent({
    name: "ViewMarchandPage",
    components: {
      BreadCrumb,
      ViewMarchand,
    },
  });
</script>